import React from 'react';
import Button from 'material-ui/Button/Button';
import Console from '../../../lib/debug';

const PrimaryButton = props => {
    Console.render('PrimaryButton');
    let classes = 'th-primary-button ' + props.className;
    classes += props.disabled ? ' th-primary-button--disabled' : '';
    const testid = props.testid ? props.testid : '';

    return (
        <Button
            href={props.href}
            variant="raised"
            className={classes}
            onClick={props.onClick}
            disabled={props.disabled}
            data-testid={`${testid}-primary-button`}
        >
            {props.children}
        </Button>
    );
};

export default PrimaryButton;
